module.exports = __webpack_public_path__ + "static/media/drop-17-1@1x.454a575c.png";